<h1 mat-dialog-title> Valida Reembolso </h1> <br/>

<mat-dialog-content>

    <p>
        <mat-form-field appearance = "outline" class = "mat-input">

            <mat-label> Beneficiario </mat-label>

            <mat-select *ngIf = "data.carga" [(ngModel)] = "data.beneficiario.id" [disabled] = "true" required>

                <mat-option *ngFor = "let postulante of data.postulantes" value = "{{postulante.id}}">

                    {{postulante.rut}} - {{postulante.dv}} {{postulante.nombres}} {{postulante.apellidoPaterno}}

                </mat-option>

            </mat-select>

            <input *ngIf = "!data.carga" matInput [disabled] = "true" [value] = "data.beneficiario.descripcion" />

        </mat-form-field>
    </p>

    <p>
        <mat-form-field appearance = "outline" class = "mat-input">

            <mat-label> Tipo de Reembolso </mat-label>

            <mat-select [(ngModel)] = "data.tipoReembolso" [disabled] = "data.deshabilitado" required
            (selectionChange) = "seleccionaTipo()">

                <mat-option *ngFor = "let tipo of data.tiposReembolso" value = "{{tipo.id}}">

                    {{tipo.descripcion}}

                </mat-option>

            </mat-select>

        </mat-form-field>
    </p>

    <p>
        <mat-form-field appearance = "outline" class = "mat-input">

            <mat-label> Categoría de Reembolso </mat-label>

            <mat-select [(ngModel)] = "data.reembolsoCategoria" [disabled] = "data.deshabilitado" required
            (selectionChange) = "seleccionaCategoria()">

                <mat-option *ngFor = "let categoria of data.categorias" value = "{{categoria.id}}">

                    {{categoria.descripcion}}

                </mat-option>

            </mat-select>

        </mat-form-field>
    </p>

    <p>
        <mat-form-field appearance = "outline" class = "mat-input">

            <mat-label> SubCategoría de Reembolso </mat-label>

            <mat-select [(ngModel)] = "data.reembolsoSubcategoria" [disabled] = "data.deshabilitado" required>

                <mat-option *ngFor = "let subcategoria of data.subcategorias" value = "{{subcategoria.id}}">

                    {{subcategoria.descripcion}}

                </mat-option>

            </mat-select>

        </mat-form-field>
    </p>

    <p>
        <mat-form-field appearance = "outline" class = "mat-input">

            <mat-label> Tipo de Documento </mat-label>

            <mat-select [(ngModel)] = "data.tipoDocumento" [disabled] = "data.deshabilitado" required>

                <mat-option *ngFor = "let tipoDocumento of data.tiposDocumento" value = "{{tipoDocumento}}">

                    {{tipoDocumento}}

                </mat-option>

            </mat-select>

        </mat-form-field>
    </p>

    <p>
        <mat-form-field appearance = "outline" class = "mat-input">

            <mat-label> RUT Prestador </mat-label>

            <input matInput placeholder = "RUT Prestador" [(ngModel)] = "data.rutPrestador" required
            [disabled] = "data.deshabilitado"  pattern = "[0-9.]{7,10}[-]{1}[0-9Kk]{1}">

        </mat-form-field>
    </p>

    <p>
        <mat-form-field appearance = "outline" class = "mat-input">

            <mat-label> Folio de Documento </mat-label>

            <input matInput type = "number" placeholder = "Folio de Documento" [(ngModel)] = "data.nDocumento"
            [disabled] = "data.deshabilitado" required>

        </mat-form-field>
    </p>

    <p>
        <mat-form-field appearance = "outline" class = "mat-input">

            <mat-label> Número de Boleta/Voucher</mat-label>

            <input matInput type = "number" placeholder = "Numero de boleta" [(ngModel)] = "data.nBoleta"
            [disabled] = "data.deshabilitado" required>

        </mat-form-field>
    </p>

    <p>
        <mat-form-field appearance = "outline" class = "mat-input">

            <mat-label> Monto Copago </mat-label>

            <input matInput type = "number" placeholder = "Monto Copago" [(ngModel)] = "data.montoCopago"
            [disabled] = "data.deshabilitado" required>

        </mat-form-field>
    </p>

    <p>
        <mat-form-field appearance = "outline" class = "mat-input">

            <mat-label> Monto Reembolso Calculado </mat-label>

            <input matInput placeholder = "Monto Copago" [(ngModel)] = "data.montoReembolso" [disabled] = "true">

        </mat-form-field>
    </p>

    <p>
        <mat-form-field appearance = "outline" class = "mat-input">

            <mat-label> Fecha Documento </mat-label>

            <input matInput type = "date" placeholder = "Fecha Documento" [(ngModel)] = "data.fechaDocumento"
            [disabled] = "data.deshabilitado" required>

        </mat-form-field>
    </p>
    <p>
        <mat-form-field appearance = "outline" class = "mat-input">

            <mat-label> Cobertura de su Sistema de Salud </mat-label>

            <mat-select [(ngModel)] = "data.prevision" [disabled] = "data.deshabilitado" required>

                <mat-option *ngFor = "let prevision of data.previsiones" value = "{{prevision.id}}">

                    {{prevision.nombre}}

                </mat-option>

            </mat-select>

        </mat-form-field>
    </p>
    <p>
        <mat-form-field appearance = "outline" class = "mat-input">

            <mat-label> Folio externo </mat-label>

            <input matInput placeholder = "Folio externo" [(ngModel)] = "data.folioExterno" [disabled] = "true">

        </mat-form-field>
    </p>

    <p>
        <mat-form-field appearance = "outline" class = "mat-input">

            <mat-label> Observación </mat-label>
            <textarea matInput placeholder = "ingrese una Observación" name="observacion"  id="observacion" [(ngModel)]="data.observacion"
            [disabled] = "data.deshabilitado"  cols="40" rows="5" maxlength="500"  >
            </textarea>

        </mat-form-field>
    
    </p>
   

    <p>
        <button class = "mat-raised-button btn-info" (click) = "onDescargarArchivosClick(data.idPostulacion)">

        <i class = "fa fa-download"> </i> Ver Archivo(s) Ingresado(s) </button>
    </p>


    
    <div class="row ">

        <div class="col-lg-1"> </div>

        <div class="col-lg-3">
            <p> Adjuntar </p>
        </div>

        <div class="col-lg-5">

            <input type="file" class="form-control-file" name="archivo" required
                accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="data.archivoTest"
                (change)="seleccionaArchivo($event, 0)" [disabled]="data.deshabilitado">

        </div>

        <div class="col-lg-1"> </div>

        <div class="col-lg-1"> <button [disabled]="data.deshabilitado" class="btn btn-info"
                (click)="sumaArchivo()"> + </button> </div>
        <div class="col-lg-1"> </div>

    </div>
    <br />

    <div *ngIf="data.cantidadArchivos > 1" class="row line">

        <div class="col-lg-1"> </div>

        <div class="col-lg-3">
            <p> Adjuntar (2) </p>
        </div>

        <div class="col-lg-5">
            <input type="file" class="form-control-file" name="archivo2" required
                accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="data.archivoTest2"
                (change)="seleccionaArchivo($event, 1)">
        </div>

        <div class="col-lg-1"> </div>

        <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

        <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

    </div>
    <br />
   

</mat-dialog-content> <br/>

<mat-dialog-actions>
    <div *ngIf = "data.rol != 'ROLE_EJECUTIVO_CAIP';  else roleReadOnly">
        <button *ngIf = "!data.presionaEditar && data.mostrarEditar && data.disponiblePago && data.mostrarAprobarButton" mat-button class = "mat-raised-button btn-warning" (click) = "onEditarClick()">
            <i class ="fa fa-pen"> </i> Editar
        </button>

        <button *ngIf = "!data.presionaEditar && data.mostrarEditar && data.mostrarAprobarButton" mat-button class = "mat-raised-button btn-success" (click) = "onAprobarClick(data.idPostulacion, data.carga ? data.beneficiario : null, !data.carga ? data.beneficiario : null)">
            <i class = "fa fa-check"> </i> Aprobar
        </button>
        
        <button *ngIf = "!data.presionaEditar && data.mostrarEditar && data.mostrarEnviarButton" mat-button class = "mat-raised-button btn-secondary" (click) = "onEnviarClick(data.idPostulacion, data.carga ? data.beneficiario : null, !data.carga ? data.beneficiario : null)">
            <i class = "fa fa-envelope"> </i> Enviar a la compañía
        </button>

        <button *ngIf = "!data.presionaEditar && data.mostrarEditar && data.disponiblePago &&data.mostrarAprobarButton" mat-button class = "mat-raised-button btn-danger" (click) = "onRechazarClick(data.idPostulacion)">
            <i class = "fa fa-times"> </i> Rechazar
        </button>

        <button *ngIf = "data.presionaEditar && data.mostrarEditar && data.disponiblePago" mat-button class = "mat-raised-button btn-success"
        (click) = "onGuardarClick(data.idPostulacion, data.carga ? data.beneficiario : null, !data.carga ? data.beneficiario : null)">
            <i class = "fa fa-download"> </i> Guardar
        </button>
        <button mat-button class = "mat-raised-button btn-dark" (click) = "onCancelarClick()">
            <i class = "fa fa-trash"> </i> Salir
        </button>
    </div>
    <ng-template #roleReadOnly>
        <button mat-button class = "mat-raised-button btn-dark" (click) = "onCancelarClick()">
            <i class = "fa fa-trash"> </i> Salir
        </button>
    </ng-template> 

</mat-dialog-actions>
